import { connect } from "react-redux";
import React from "react";
import { withRouter } from "react-router-dom";
import appStoreBadge from "../../assests/images/Group 1399.png";
import "../style/main.css";
import "../style/authFooter.css";

function FooterComponent() {
  return (
    <footer className="auth-footer">
      <div className="auth-footer-inner">
        <p className="auth-footer-copy">
          © {new Date().getFullYear()} WatchOps. All rights reserved.
        </p>
        <nav className="auth-footer-nav" aria-label="Footer">
          <a href="https://watchops.com/">Home</a>
          <span className="auth-footer-pipe" aria-hidden="true">
            |
          </span>
          <a href="https://watchops.com/schedule-a-demo/">Schedule a Demo</a>
          <span className="auth-footer-pipe" aria-hidden="true">
            |
          </span>
          <a href="https://watchops.com/contact-us/">Contact us</a>
          <span className="auth-footer-pipe" aria-hidden="true">
            |
          </span>
          <a href="https://watchops.com/terms-of-use/">Terms of Use</a>
          <span className="auth-footer-pipe" aria-hidden="true">
            |
          </span>
          <a href="https://watchops.com/terms-of-service/">Terms of Service</a>
          <span className="auth-footer-pipe" aria-hidden="true">
            |
          </span>
          <a href="https://watchops.com/privacy-policy/">Privacy Policy</a>
        </nav>
        <div className="auth-footer-stores">
          <a
            href="https://apps.apple.com/us/app/watchops/id1568919499"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download on the App Store"
          >
            <img src={appStoreBadge} alt="Download on the App Store" />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default connect(null, null)(withRouter(FooterComponent));
